import React, { useState, useEffect } from "react";
import { Card } from "../../../../shared/Card/Card";
import { getPerformanceMetrics, getOverallScore } from "./utils/rubricUtils";
import { Metric } from "./types";
import InterviewRubricStats from "./InterviewRubricStats";
import PerformanceGauge from "./PerformanceGauge";
import PerformanceMetricsGrid from "./PerformanceMetricsGrid";
import DetailedMetricView from "./DetailedMetricView";
import "./tabs.scss";

interface InterviewRubricTabProps {
  feedback: any;
  evaluations: any[];
  interview: any;
}

const InterviewRubricTab: React.FC<InterviewRubricTabProps> = ({
  feedback,
  evaluations,
  interview,
}) => {
  const [selectedMetric, setSelectedMetric] = useState<string | null>(null);

  useEffect(() => {
    if (feedback) {
      const metrics = getPerformanceMetrics(feedback);
      if (metrics.length > 0) {
        setSelectedMetric(metrics[0].id);
      }
    }
  }, [feedback]);

  if (!feedback) {
    return (
      <div className="interview-rubric-tab">
        <Card>
          <div className="tab-content-wrapper">
            <div className="no-data-message">
              No feedback data available for this interview.
            </div>
          </div>
        </Card>
      </div>
    );
  }

  const metrics = getPerformanceMetrics(feedback);
  const selectedMetricData = metrics.find((m) => m.id === selectedMetric);
  const overallScore = getOverallScore(feedback);

  return (
    <div className="interview-rubric-tab">
      <div className="rubric-tab-content">
        {/* Stats Grid */}
        <InterviewRubricStats
          feedback={feedback}
          evaluations={evaluations}
          interview={interview}
        />

        {/* Performance Gauge */}
        <Card>
          <div className="performance-gauge-container">
            <PerformanceGauge score={overallScore} />
          </div>
        </Card>

        {/* Performance Metrics Grid */}
        <PerformanceMetricsGrid
          metrics={metrics}
          selectedMetric={selectedMetric}
          onMetricSelect={setSelectedMetric}
        />

        {/* Detailed Metric View */}
        {selectedMetricData && (
          <Card>
            <DetailedMetricView metric={selectedMetricData} />
          </Card>
        )}
      </div>
    </div>
  );
};

export default InterviewRubricTab;
